import React from 'react';
import { StatusToggle } from './StatusToggle';
import type { Show, ShowStatus } from '../types/show';
interface ShowRowProps {
  show: Show;
  status?: ShowStatus;
  onToggle: (rank: number, status: ShowStatus) => void;
}
export function ShowRow({
  show,
  status,
  onToggle
}: ShowRowProps) {
  const seen = status === 'seen';
  return <li className="flex break-inside-avoid items-center border-b border-rule" data-id="element-73" data-mp="35g04taoavg1m">
      <span className="w-10 shrink-0 font-sans text-sm font-bold tabular-nums text-ink" data-id="element-74" data-mp="3t6dwv16vxew7">
        {show.rank}.
      </span>
      <button type="button" tabIndex={-1} aria-hidden="true" onClick={() => onToggle(show.rank, 'seen')} className="min-w-0 flex-1 py-2 pr-2 text-left font-sans text-[15px] leading-snug" data-id="element-75" data-mp="10h0wrc9nt8e">
        <span className={`font-bold ${seen ? 'text-ink' : 'text-ink'}`} data-id="element-76" data-mp="27rzpa9acohbg">{show.title}</span>{' '}
        <span className="whitespace-nowrap text-muted" data-id="element-77" data-mp="2cqt1lydwi2a1">({show.years})</span>
      </button>
      <StatusToggle kind="seen" checked={seen} label={`I've seen ${show.title}`} onToggle={() => onToggle(show.rank, 'seen')} data-id="element-78" data-mp="2coggjccujbsr" />
      <StatusToggle kind="want" checked={status === 'want'} label={`I want to see ${show.title}`} onToggle={() => onToggle(show.rank, 'want')} data-id="element-79" data-mp="1z2k15vt4j4kc" />
    </li>;
}